@if (loading || charts.length) {
    <div class="panel-head">
        <h3 class="m-0 text-lg font-bold">{{ title }}</h3>
        @if (scope === 'account') {
            <a class="panel-link" routerLink="/performance">{{ linkLabel }}</a>
        }
    </div>

    @if (loading) {
        <app-loading-indicator></app-loading-indicator>
    } @else {
        <!--
          Each chart is its own card. Nesting them inside one drew a card in a
          card and left the panel reading as a single block rather than as two
          separate measurements.
        -->
        <div class="charts" [class.stacked]="compact">
            @for (chart of charts; track chart.key) {
                <section class="chart">
                    <div class="chart-head">
                        <span class="chart-title">{{ chart.title }}</span>
                        <span class="chart-caption">{{ chart.caption }}</span>
                    </div>
                    <div class="chart-headline">
                        <span class="headline-value">{{ chart.headline }}</span>
                        <span class="headline-label">{{ chart.headlineLabel }}</span>
                    </div>
                    <div class="chart-canvas">
                        <canvas #chartCanvas></canvas>
                    </div>
                </section>
            }
        </div>
    }
}
